<template>
  <div
    ref="chartSvgs"
    class="chart-legend"
  >
    <span class="legend-item">
      <div
        class="legend-swatch"
        style="background-color: #50847B33"
      />
      Noise Event
    </span>
    <span class="legend-item">
      <div
        class="legend-swatch"
        style="background-color: #AEAEAE33"
      />
      Disconnect Event
    </span>
    <span class="legend-item">
      <div>
        <font-awesome-layers
          style="vertical-align: -0.125em;"
          class="fa-lg mr-1"
        >
          <font-awesome-icon
            :icon="['fas','circle']"
            :style="{ color: '#363636' }"
            transform="grow-3"
          />
          <font-awesome-icon
            :icon="['fas','comment']"
            :style="{ color: 'white' }"
            transform="shrink-5"
          />

        </font-awesome-layers>
        Alert Sent
      </div>
    </span>
    <span class="legend-item">
      <div
        class="legend-line"
        style="border-bottom-style:solid"
      />Noise Level
    </span>
    <span class="legend-item">
      <div
        class="legend-line-dashed"
      />
      Threshold
    </span>
  </div>
</template>

<script>
  export default {
    name: 'ValkyrieGraphLegend',
  }
</script>

<style lang="scss" scoped>
.chart-legend {
    max-height:2rem;
    padding:.5rem 0;
    display:flex;
    justify-content: flex-end;
    span {
      font-size:.85rem;
      font-weight:500;
    }
    .legend-item {
      display:flex;
      align-items:center;
      flex: none;
      margin: 0 5px;
      .status {
        font-size:.55rem;
        margin-right:.3rem;
      }
      .legend-line {
        width: 2rem;
        border-bottom-color:#535353;
        border-bottom-width:2px;
        margin-right:.3rem;
      }
      .legend-swatch {
        height: 21px;
        width: 21px;
        margin-right: 6px;
      }
      .legend-line-dashed {
        width: 2rem;
        color:#535353;
        margin-right:.3rem;
        &::before {
          content: "---";
          letter-spacing: 4px;
          font-weight: 900;
          font-size: 1rem;
        }
      }
    }
  }
</style>
